import React, { Fragment, FunctionComponent } from 'react';
import styles from './HeroImageTop.module.scss';
import { Block, ResponsiveImage, Typography, BlockContent, Button } from 'components/elements';
import { WPAcfHeroImageTop } from 'types/acf/hero';
import HeroImageTopLogos from './HeroImageTopLogos';

interface OwnProps {
  data: WPAcfHeroImageTop | null;
}

type HeroImageTopProps = JSX.IntrinsicElements['div'] & OwnProps;

const HeroImageTop: FunctionComponent<HeroImageTopProps> = props => {
  const { data } = props;

  if (!data) {
    return null;
  }

  const { buttonLabel, buttonLink, description, desktopImage, header, headersOrder, mobileImage, subheader } = data;
  const isOrderNormal = headersOrder === 'normal';

  return (
    <Fragment>
      <Block id="hero-image-top" width="full" theme="light" data-module="hero-image-top">
        <ResponsiveImage
          priority={true}
          className={styles.backImage}
          desktopImage={{ config: desktopImage, imgProps: { width: 1080, height: 790 } }}
          mobileImage={{ config: mobileImage || desktopImage, imgProps: { sizes: '100vw' } }}
        />
        <BlockContent className={styles.container}>
          {subheader && !isOrderNormal && (
            <Typography mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h2" className={styles.subheader}>
              {subheader}
            </Typography>
          )}
          {header && (
            <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="h1" className={styles.header}>
              {header}
            </Typography>
          )}
          {subheader && isOrderNormal && (
            <Typography mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h2" className={styles.subheader}>
              {subheader}
            </Typography>
          )}
          {description && (
            <Typography as="p" mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" className={styles.description}>
              {description}
            </Typography>
          )}
          {buttonLabel && buttonLink && (
            <div className={styles.link}>
              <Button href={buttonLink} as="a">
                {buttonLabel}
              </Button>
            </div>
          )}
        </BlockContent>
      </Block>
      <HeroImageTopLogos data={data} />
    </Fragment>
  );
};

export default HeroImageTop;
